module.exports = __webpack_public_path__ + "files/605f219523de1884df6655366b9cd2c3.jpg";